import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ClipboardPage } from './pages/ClipboardPage';
import { Toaster } from './components/Toaster';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/:id" element={<ClipboardPage />} />
      </Routes>
      <Toaster />
    </Router>
  );
}

export default App;